// RefundsTable.jsx
import React from 'react';
import Pagination from '../nav/Pagination';
import Empty from '../feedback/Empty';
import moment from 'moment';
import utils from '../../utils';
import { useAuth } from '../../context/UserContext';

function RefundsTable({ refunds, openModal, changePageParam }) {
    const { user } = useAuth()
    return (
        <div className="p-3 bg-white dark:bg-slate-800 rounded-lg shadow-sm hover:shadow-md overflow-hidden border border-border-light dark:border-border-dark">
            <div className="overflow-x-auto">
                <table className="table table-compact table-zebra w-full">
                    <thead>
                        <tr>

                            {(user?.is_admin || user?.is_vendor) && (
                                <th>Customer</th>
                            )}
                            <th className="hidden sm:table-cell">Product</th>
                            <th>Status</th>
                            <th>Total</th>
                            <th className="hidden md:table-cell">Created</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {refunds?.results?.map((refund, idx) => (
                            <tr key={refund.id || idx}>
                                {(user?.is_admin || user?.is_vendor) && (
                                    <td className="hidden sm:table-cell">
                                        <div className="flex items-center gap-3">
                                            <div className="avatar placeholder">
                                                <div className="bg-neutral text-white rounded-full w-11">
                                                    <span className="text-lg">{utils.makeProfileLetter(refund.owner)}</span>
                                                </div>
                                            </div>
                                            <div>
                                                {refund?.owner?.full_name && (
                                                    <div className='font-bold'>
                                                        {refund.owner?.full_name || '—'}
                                                    </div>
                                                )}
                                                <div className='text-gray-600'>
                                                    {refund.owner?.email || '—'}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                )}
                                <td >
                                    <div className="flex items-center gap-3">
                                        <div>
                                            <img
                                                className='h-10 rounded-lg'
                                                src={utils.baseUrl + refund?.product_image} alt="" />
                                        </div>
                                        <div>
                                            <div className="font-bold">{refund.cart_item?.product?.name || '—'}</div>
                                            {refund.cart_item?.product?.store_name && (
                                                <div className="text-sm text-gray-500">
                                                    <span>Store:</span> {refund.cart_item?.product?.store_name}
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </td>

                                <td>
                                    <span
                                        className={`${refund.is_resolved
                                            ? 'text-success'
                                            : 'text-warning'
                                            }`}
                                    >
                                        {refund.is_resolved ? 'Resolved' : 'Pending'}
                                    </span>
                                </td>
                                <td className='font-bold'>
                                    {utils.toCommas(refund?.cart_item?.total || 0)}
                                </td>
                                <td className="hidden md:table-cell">
                                    {moment(refund.creation_time).format('MMM D, YYYY')}
                                </td>
                                <td>
                                    <button
                                        onClick={() => openModal(refund)}
                                        className="btn btn-sm btn-primary"
                                    >
                                        View
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {refunds?.count === 0 && <Empty objectName="refunds" />}

                {refunds?.count > 0 && (
                    <div className="mt-6 flex justify-center">
                        <Pagination
                            count={refunds.count}
                            next={refunds.next}
                            previous={refunds.previous}
                            changePageParam={changePageParam}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default RefundsTable;